<template>
  <Drawer title="异常自查" width="1024" :closable="false" v-model="_value">
    <Collapse v-model="Collapsevalue1" accordion simple>
      <Panel name="1">
        惠州博实结科技有限公司
        <template #content>
          <div>
            <Collapse v-model="Collapsevalue" accordion simple>
              <Panel name="1-1">
                北斗双模部标机（BSJ_A6BD）
                <template #content>
                  <Button type="primary" size="small" @click="BSJ_A6BD_off_linemodal = true" style="margin: 10px;">离线</Button>
                  <Button type="primary" size="small" @click="BSJA6BD1DPositioningmodal = true" style="margin: 10px;">不定位</Button>

                  <b-s-j-a6-b-d-off-linemodal v-model="BSJ_A6BD_off_linemodal" :initValue="BSJ_A6BD_off_lineId"></b-s-j-a6-b-d-off-linemodal>
                  <b-s-j-a6-b-d1-d-positioning-modal v-model="BSJA6BD1DPositioningmodal" :initValue="BSJA6BD1DPositioningId"></b-s-j-a6-b-d1-d-positioning-modal>

                </template>
              </Panel>
              <Panel name="1-2">
                GF03视频机（BSJ_GF03）
                <template #content>
                  <Button type="primary" size="small" @click="BSJ_A6BD_off_linemodal = true" style="margin: 10px;">离线</Button>
                  <Button type="primary" size="small" @click="BSJA6BD1DPositioningmodal = true" style="margin: 10px;">不定位</Button>
                  <Button type="primary" size="small" @click="BSJVideoLossmodal = true" style="margin: 10px;">视频失效</Button>
                  <Button type="primary" size="small" @click="BSJHardDiskNotDetectedmodal = true" style="margin: 10px;">未检测到硬盘</Button>

                  <b-s-j-video-loss-modal v-model="BSJVideoLossmodal" :initValue="BSJVideoLossId"></b-s-j-video-loss-modal>
                  <b-s-j-hard-disk-not-detected-modal v-model="BSJHardDiskNotDetectedmodal" :initValue="BSJHardDiskNotDetectedId"></b-s-j-hard-disk-not-detected-modal>

                </template>
              </Panel>
              <Panel name="1-3">
                GF06视频机（BSJ_GF06）
                <template #content>
                  <Button type="primary" size="small" @click="BSJ_A6BD_off_linemodal = true" style="margin: 10px;">离线</Button>
                  <Button type="primary" size="small" @click="BSJA6BD1DPositioningmodal = true" style="margin: 10px;">不定位</Button>
                  <Button type="primary" size="small" @click="BSJVideoLossmodal = true" style="margin: 10px;">视频失效</Button>
                  <Button type="primary" size="small" @click="BSJHardDiskNotDetectedmodal = true" style="margin: 10px;">未检测到硬盘</Button></template>
              </Panel>
              <Panel name="1-4">
                行车记录仪（BSJ-GH03T）
                <template #content>
                  <Button type="primary" size="small" @click="BSJ_A6BD_off_linemodal = true" style="margin: 10px;">离线</Button>
                  <Button type="primary" size="small" @click="BSJA6BD1DPositioningmodal = true" style="margin: 10px;">不定位</Button>
                  <Button type="primary" size="small" @click="BSJVideoLossmodal = true" style="margin: 10px;">视频失效</Button>
                </template>
              </Panel>
              <Panel name="1-5">
                小终端（BSJ_RM01）
                <template #content>
                  <Button type="primary" size="small" @click="BSJ_A6BD_off_linemodal = true" style="margin: 10px;">离线</Button>
                  <Button type="primary" size="small" @click="BSJA6BD1DPositioningmodal = true" style="margin: 10px;">不定位</Button>
                </template>
              </Panel>
            </Collapse>
          </div>

        </template>
      </Panel>
      <Panel name="2">
        深圳市锐明技术股份有限公司
        <template #content>
          <img src="/RM/distinguish.jpg" style="width: 780px">
          <div>
            <Collapse v-model="Collapsevalue" accordion simple>
              <Panel name="2-1">
                非粤标视频机（HDD，D5X，XRV2）
                <template #content>
                  <Button type="primary" size="small" @click="RMOffLinemodal = true" style="margin: 10px;">离线</Button>
                  <Button type="primary" size="small" @click="RM1DPositioningmodal = true" style="margin: 10px;">不定位</Button>
                  <Button type="primary" size="small" @click="RMVideoLossmodal = true" style="margin: 10px;">视频失效</Button>
                  <Button type="primary" size="small" @click="RMHardDiskNotDetectedmodal = true" style="margin: 10px;">未检测到硬盘</Button>
                  <Button type="primary" size="small" @click="RMLossAttachmentmodal = true" style="margin: 10px;">附件丢失</Button>
                  <Button type="primary" size="small" @click="RMExchangePlatformmodal = true" style="margin: 10px;">对接平台</Button>

                  <r-m-off-line-modal v-model="RMOffLinemodal" :initValue="RMOffLineId"></r-m-off-line-modal>
                  <r-m1-d-positioning-modal v-model="RM1DPositioningmodal" :initValue="RM1DPositioningId"></r-m1-d-positioning-modal>
                  <r-m-video-loss-modal v-model="RMVideoLossmodal" :initValue="RMVideoLossId"></r-m-video-loss-modal>
                  <r-m-hard-disk-not-detected-modal v-model="RMHardDiskNotDetectedmodal" :initValue="RMHardDiskNotDetectedId"></r-m-hard-disk-not-detected-modal>
                  <r-m-loss-attachment-modal v-model="RMLossAttachmentmodal" :initValue="RMLossAttachmentId"></r-m-loss-attachment-modal>
                  <r-m-exchange-platform-modal v-model="RMExchangePlatformmodal" :initValue="RMExchangePlatformId"></r-m-exchange-platform-modal>

                </template>
              </Panel>
              <Panel name="2-2">
                粤标视频机（XRV4）
                <template #content>
                  <Button type="primary" size="small" @click="RMOffLinemodal = true" style="margin: 10px;">离线</Button>
                  <Button type="primary" size="small" @click="RM1DPositioningmodal = true" style="margin: 10px;">不定位</Button>
                  <Button type="primary" size="small" @click="RMVideoLossmodal = true" style="margin: 10px;">视频失效</Button>
                  <Button type="primary" size="small" @click="RMHardDiskNotDetectedmodal = trupgradationue" style="margin: 10px;">未检测到硬盘</Button>
                  <Button type="primary" size="small" @click="RMLossAttachmentmodal = true" style="margin: 10px;">附件丢失</Button>
                  <Button type="primary" size="small" @click="RMExchangePlatformmodal = true" style="margin: 10px;">对接平台</Button>
                </template>
              </Panel>
            </Collapse>
          </div>

          <Button type="primary" size="small" @click="openpdf('/RM/RM-CEIBAVehicleinfo.pdf')" style="margin: 10px;">CEIBA录入车辆</Button>
          <Button type="primary" size="small" @click="openpdf('/RM/RM-real-time video.pdf')" style="margin: 10px;">CEIBA-实时视频</Button>
          <Button type="primary" size="small" @click="openpdf('/RM/RM-ExportVideo.pdf')" style="margin: 10px;">CEIBA-导出视频</Button>
          <Button type="primary" size="small" @click="openpdf('/RM/RM-AlarmSetting.pdf')" style="margin: 10px;">报警设置</Button>
          <Button type="primary" size="small" @click="openpdf('/RM/RM-SpeedAlarmSetting.pdf')" style="margin: 10px;">速度报警设置</Button>
          <Button type="primary" size="small" @click="openpdf('/RM/RM-SetCameraDirection.pdf')" style="margin: 10px;">摄像头画面旋转</Button>
          <Button type="primary" size="small" @click="openpdf('/RM/RM-SetAICamera.pdf')" style="margin: 10px;">驾驶舱（司机头顶）摄像头标定</Button>
          <Button type="primary" size="small" @click="openpdf('/RM/RM-DelayedsShutdown.pdf')" style="margin: 10px;">延时关机（关机录像）</Button>
          <Button type="primary" size="small" @click="openpdf('/RM/RM-Update.pdf')" style="margin: 10px;">设备升级</Button>

        </template>
      </Panel>
      <Panel name="3">
        杭州海康汽车技术有限公司
        <template #content>
          <div>
            <Collapse v-model="Collapsevalue" accordion simple>
              <Panel name="3-1">
                非粤标视频机（AE-AC3160-A）
                <template #content>
                  <Button type="primary" size="small" @click="HIKOffLinemodal = true" style="margin: 10px;">离线</Button>
                  <Button type="primary" size="small" @click="HIK1DPositioningmodal = true" style="margin: 10px;">不定位</Button>
                  <Button type="primary" size="small" @click="HIKVideoLossmodal = true" style="margin: 10px;">视频失效</Button>
                  <Button type="primary" size="small" @click="HIKHardDiskNotDetectedmodal = true" style="margin: 10px;">未检测到硬盘</Button>
                  <Button type="primary" size="small" @click="HIKLossAttachmentmodal = true" style="margin: 10px;">附件丢失</Button>
                  <Button type="primary" size="small" @click="HIKExchangePlatformmodal = true" style="margin: 10px;">对接平台</Button>
                </template>
              </Panel>
              <Panel name="3-2">
                粤标视频机（AE-AC3141-A，AE-AC3141-A/HYB）
                <template #content>
                  <Button type="primary" size="small" @click="HIKOffLinemodal = true" style="margin: 10px;">离线</Button>
                  <Button type="primary" size="small" @click="HIK1DPositioningmodal = true" style="margin: 10px;">不定位</Button>
                  <Button type="primary" size="small" @click="HIKVideoLossmodal = true" style="margin: 10px;">视频失效</Button>
                  <Button type="primary" size="small" @click="HIKHardDiskNotDetectedmodal = true" style="margin: 10px;">未检测到硬盘</Button>
                  <Button type="primary" size="small" @click="HIKLossAttachmentmodal = true" style="margin: 10px;">附件丢失</Button>
                  <Button type="primary" size="small" @click="HIKExchangePlatformmodal = true" style="margin: 10px;">对接平台</Button>

                  <h-i-k-off-line-modal v-model="HIKOffLinemodal" :initValue="HIKOffLineId"></h-i-k-off-line-modal>
                  <h-i-k1-d-positioning-modal v-model="HIK1DPositioningmodal" :initValue="HIK1DPositioningId"></h-i-k1-d-positioning-modal>
                  <h-i-k-video-loss-modal v-model="HIKVideoLossmodal" :initValue="HIKVideoLossId"></h-i-k-video-loss-modal>
                  <h-i-k-hard-disk-not-detected-modal v-model="HIKHardDiskNotDetectedmodal" :initValue="HIKHardDiskNotDetectedId"></h-i-k-hard-disk-not-detected-modal>
                  <h-i-k-loss-attachment-modal v-model="HIKLossAttachmentmodal" :initValue="HIKLossAttachmentId"></h-i-k-loss-attachment-modal>
                  <h-i-k-exchange-platform-modal v-model="HIKExchangePlatformmodal" :initValue="HIKExchangePlatformId"></h-i-k-exchange-platform-modal>

                </template>
              </Panel>
              <Panel name="3-3">
                国标视频机（AE-AC4204）
                <template #content>
                  <Button type="primary" size="small" @click="HIKOffLinemodal = true" style="margin: 10px;">离线</Button>
                  <Button type="primary" size="small" @click="HIK1DPositioningmodal = true" style="margin: 10px;">不定位</Button>
                  <Button type="primary" size="small" @click="HIKVideoLossmodal = true" style="margin: 10px;">视频失效</Button>
                  <Button type="primary" size="small" @click="HIKHardDiskNotDetectedmodal = true" style="margin: 10px;">未检测到硬盘</Button>
                </template>
              </Panel>
              <Panel name="3-4">
                行车记录仪（AE-DI2032-G40）
                <template #content>
                  <Button type="primary" size="small" @click="HIKOffLinemodal = true" style="margin: 10px;">离线</Button>
                  <Button type="primary" size="small" @click="HIK1DPositioningmodal = true" style="margin: 10px;">不定位</Button>
                  <Button type="primary" size="small" @click="HIKVideoLossmodal = true" style="margin: 10px;">视频失效</Button>
                  <Button type="primary" size="small" @click="HIKHardDiskNotDetectedmodal = true" style="margin: 10px;">未检测到硬盘</Button>
                </template>
              </Panel>
            </Collapse>
          </div>

          <Button type="primary" size="small" @click="openpdf('/HIK/HIK-Vehicleinfo.pdf')" style="margin: 10px;">运维录入</Button>
          <Button type="primary" size="small" @click="openpdf('/HIK/HIK-AlarmSetting.pdf')" style="margin: 10px;">报警设置</Button>
<!--          <Button type="primary" size="small" @click="openpdf('/HIK/HIK-AlarmSetting.pdf')" style="margin: 10px;">HIK-手机APP-导出视频</Button>-->
          <Button type="primary" size="small" @click="openpdf('/HIK/HIK-HornSwitching.pdf')" style="margin: 10px;">喇叭切换</Button>
          <Button type="primary" size="small" @click="openpdf('/HIK/HIK-SpeedAlarmSetting.pdf')" style="margin: 10px;">速度报警设置</Button>
          <Button type="primary" size="small" @click="openpdf('/HIK/HIK-DelayedsShutdown.pdf')" style="margin: 10px;">延时关机（关机录像）</Button>

        </template>
      </Panel>
      <Panel name="4">
        江苏中天安驰科技有限公司
        <template #content>
          <div>
            <Collapse v-model="Collapsevalue" accordion simple>
              <Panel name="4-1">
                粤标视频机（P9S）
                <template #content>
                  <Button type="primary" size="small" @click="ZTOffLinemodal = true" style="margin: 10px;">离线</Button>
                  <Button type="primary" size="small" @click="ZT1DPositioningmodal = true" style="margin: 10px;">不定位</Button>
                  <Button type="primary" size="small" @click="ZTVideoLossmodal = true" style="margin: 10px;">视频失效</Button>
                  <Button type="primary" size="small" @click="ZTHardDiskNotDetectedmodal = true" style="margin: 10px;">未检测到硬盘</Button>
                  <Button type="primary" size="small" @click="ZTLossAttachmentmodal = true" style="margin: 10px;">附件丢失</Button>
                  <Button type="primary" size="small" @click="ZTExchangePlatformmodal = true" style="margin: 10px;">对接平台</Button>

                  <z-t-off-line-modal v-model="ZTOffLinemodal" :initValue="ZTOffLineId"></z-t-off-line-modal>
                  <z-t1-d-positioning-modal v-model="ZT1DPositioningmodal" :initValue="ZT1DPositioningId"></z-t1-d-positioning-modal>
                  <z-t-video-loss-modal v-model="ZTVideoLossmodal" :initValue="ZTVideoLossId"></z-t-video-loss-modal>
                  <z-t-hard-disk-not-detected-modal v-model="ZTHardDiskNotDetectedmodal" :initValue="ZTHardDiskNotDetectedId"></z-t-hard-disk-not-detected-modal>
                  <z-t-loss-attachment-modal v-model="ZTLossAttachmentmodal" :initValue="ZTLossAttachmentId"></z-t-loss-attachment-modal>
                  <z-t-exchange-platform-modal v-model="ZTExchangePlatformmodal" :initValue="ZTExchangePlatformId"></z-t-exchange-platform-modal>

                </template>
              </Panel>
            </Collapse>
          </div>

          <Button type="primary" size="small" @click="openpdf('/ZT/ZT-AlarmSetting.pdf')" style="margin: 10px;">报警设置</Button>
          <Button type="primary" size="small" @click="openpdf('/ZT/ZT-SpeedAlarmSetting.pdf')" style="margin: 10px;">速度报警设置</Button>

        </template>
      </Panel>

      <Panel name="5">
        两客一危平台
        <template #content>

          <Button type="primary" size="small" @click="GDGOVParameterExceptionmodal = true" style="margin: 10px;">设备巡查参数异常</Button>

          <g-d-g-o-v-parameter-exception v-model="GDGOVParameterExceptionmodal" :initValue="GDGOVParameterExceptionId"></g-d-g-o-v-parameter-exception>

        </template>
      </Panel>

      <Panel name="6">
        常见问题
        <template #content>

          <Button type="primary" size="small" @click="WireCuttingAlarmmodal = true" style="margin: 10px;">剪线报警</Button>
          <Button type="primary" size="small" @click="OvertimeDrivingAlarmmodal = true" style="margin: 10px;">超时驾驶</Button>

          <wire-cutting-alarm-modal v-model="WireCuttingAlarmmodal" :initValue="WireCuttingAlarmId"></wire-cutting-alarm-modal>
          <overtime-driving-alarm-modal v-model="OvertimeDrivingAlarmmodal" :initValue="OvertimeDrivingAlarmId"></overtime-driving-alarm-modal>

        </template>
      </Panel>

      <Panel name="7">
        ERP-功能
        <template #content>

          <Button type="primary" size="small" @click="ERPExportVideomodal = true" style="margin: 10px;">ERP：导出视频</Button>
          <Button type="primary" size="small" @click="ERPShortMessageWarningmodal = true" style="margin: 10px;">短信报警</Button>
          <Button type="primary" size="small" @click="ERPExchangePlatformmodal = true" style="margin: 10px;">客户对接其他平台</Button>
          <Button type="primary" size="small" @click="ERPExchangeAccessmodal = true" style="margin: 10px;">客户接入ERP/易流</Button>

          <e-r-p-export-video-modal v-model="ERPExportVideomodal" :initValue="ERPExportVideoId"></e-r-p-export-video-modal>
          <e-r-p-short-message-warning-modal v-model="ERPShortMessageWarningmodal" :initValue="ERPShortMessageWarningId"></e-r-p-short-message-warning-modal>
          <e-r-p-exchange-platform-modal v-model="ERPExchangePlatformmodal" :initValue="ERPExchangePlatformId"></e-r-p-exchange-platform-modal>
          <e-r-p-exchange-access-modal v-model="ERPExchangeAccessmodal" :initValue="ERPExchangeAccessId"></e-r-p-exchange-access-modal>

        </template>
      </Panel>

      <Panel name="8">
        培训会议
        <template #content>
          <div>
            <Collapse v-model="Collapsevalue" accordion simple>
              <Panel name="8-1">
                2023-07-26：中心培训
                <template #content>

                  <Button type="primary" size="small" @click="openpdf('/Meeting/20230726/BSJ.pdf')" style="margin: 10px;">博实结</Button>
                  <Button type="primary" size="small" @click="openpdf('/Meeting/20230726/HIK.pdf')" style="margin: 10px;">海康威视</Button>
                  <Button type="primary" size="small" @click="openpdf('/Meeting/20230726/RM.pdf')" style="margin: 10px;">锐明</Button>
                  <Button type="primary" size="small" @click="openpdf('/Meeting/20230726/ZT.pdf')" style="margin: 10px;">中天安驰</Button>
                  <Button type="primary" size="small" @click="openpdf('/Meeting/20230726/GDGOV.pdf')" style="margin: 10px;">两客一危平台</Button>

                </template>
              </Panel>
            </Collapse>
          </div>

        </template>
      </Panel>
    </Collapse>

        <iframe-modal v-model="Iframemodal" :initValue="IframeId"></iframe-modal>

  </Drawer>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

import IframeModal from '@/view/om/technicalassistance/components/iframe-modal'

import BSJA6BDOffLinemodal from '@/view/om/technicalassistance/components/BSJ_A6BD_off_line-modal'
import BSJA6BD1DPositioningModal from '@/view/om/technicalassistance/components/BSJ_A6BD_1D_positioning-modal'
import BSJVideoLossModal from '@/view/om/technicalassistance/components/BSJ_video_loss-modal'
import BSJHardDiskNotDetectedModal from '@/view/om/technicalassistance/components/BSJ_hard_disk_not_detected-modal'

import RMOffLineModal from '@/view/om/technicalassistance/components/RM_off_line-modal'
import RM1DPositioningModal from '@/view/om/technicalassistance/components/RM_1D_positioning-modal'
import RMVideoLossModal from '@/view/om/technicalassistance/components/RM_video_loss-modal'
import RMHardDiskNotDetectedModal from '@/view/om/technicalassistance/components/RM_hard_disk_not_detected-modal'
import RMLossAttachmentModal from '@/view/om/technicalassistance/components/RM_loss_attachment-modal'
import RMExchangePlatformModal from '@/view/om/technicalassistance/components/RM_exchange_platform-modal'

import HIKOffLineModal from '@/view/om/technicalassistance/components/HIK_off_line-modal'
import HIK1DPositioningModal from '@/view/om/technicalassistance/components/HIK_1D_positioning-modal'
import HIKVideoLossModal from '@/view/om/technicalassistance/components/HIK_video_loss-modal'
import HIKHardDiskNotDetectedModal from '@/view/om/technicalassistance/components/HIK_hard_disk_not_detected-modal'
import HIKLossAttachmentModal from '@/view/om/technicalassistance/components/HIK_loss_attachment-modal'
import HIKExchangePlatformModal from '@/view/om/technicalassistance/components/HIK_exchange_platform-modal'

import ZTOffLineModal from '@/view/om/technicalassistance/components/ZT_off_line-modal'
import ZT1DPositioningModal from '@/view/om/technicalassistance/components/ZT_1D_positioning-modal'
import ZTVideoLossModal from '@/view/om/technicalassistance/components/ZT_video_loss-modal'
import ZTHardDiskNotDetectedModal from '@/view/om/technicalassistance/components/ZT_hard_disk_not_detected-modal'
import ZTLossAttachmentModal from '@/view/om/technicalassistance/components/ZT_loss_attachment-modal'
import ZTExchangePlatformModal from '@/view/om/technicalassistance/components/ZT_exchange_platform-modal'

import GDGOVParameterException from '@/view/om/technicalassistance/components/GDGOV_parameter_exception-modal'

import WireCuttingAlarmModal from '@/view/om/technicalassistance/components/wire_cutting_alarm-modal'
import OvertimeDrivingAlarmModal from '@/view/om/technicalassistance/components/overtime_driving_alarm-modal'

import ERPExportVideoModal from '@/view/om/technicalassistance/components/ERP-export-video-modal'
import ERPShortMessageWarningModal from '@/view/om/technicalassistance/components/ERP-short-message-warning-modal'
import ERPExchangePlatformModal from '@/view/om/technicalassistance/components/ERP_exchange_platform-modal'
import ERPExchangeAccessModal from '@/view/om/technicalassistance/components/ERP_exchange_access-modal'

export default {
  name: 'bsja6bdofflinemodal',
  components: {
    IframeModal,
    BSJA6BDOffLinemodal,
    BSJA6BD1DPositioningModal,
    BSJVideoLossModal,
    BSJHardDiskNotDetectedModal,
    RMOffLineModal,
    RM1DPositioningModal,
    RMVideoLossModal,
    RMHardDiskNotDetectedModal,
    RMLossAttachmentModal,
    RMExchangePlatformModal,
    HIKOffLineModal,
    HIK1DPositioningModal,
    HIKVideoLossModal,
    HIKHardDiskNotDetectedModal,
    HIKLossAttachmentModal,
    HIKExchangePlatformModal,
    ZTOffLineModal,
    ZT1DPositioningModal,
    ZTVideoLossModal,
    ZTHardDiskNotDetectedModal,
    ZTLossAttachmentModal,
    ZTExchangePlatformModal,
    GDGOVParameterException,
    WireCuttingAlarmModal,
    OvertimeDrivingAlarmModal,
    ERPExportVideoModal,
    ERPShortMessageWarningModal,
    ERPExchangePlatformModal,
    ERPExchangeAccessModal
  },
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    },

    Iframemodal: false,
    IframeId: false
  },
  data () {
    return {
      /**
         * 博实结
         */
      BSJ_A6BD_off_linemodal: false,
      BSJ_A6BD_off_lineId: false,

      BSJA6BD1DPositioningmodal: false,
      BSJA6BD1DPositioningId: false,

      BSJVideoLossmodal: false,
      BSJVideoLossId: false,

      BSJHardDiskNotDetectedmodal: false,
      BSJHardDiskNotDetectedId: false,

      /**
         * 锐明
         */
      RMOffLinemodal: false,
      RMOffLineId: false,

      RM1DPositioningmodal: false,
      RM1DPositioningId: false,

      RMVideoLossmodal: false,
      RMVideoLossId: false,

      RMHardDiskNotDetectedmodal: false,
      RMHardDiskNotDetectedId: false,

      RMLossAttachmentmodal: false,
      RMLossAttachmentId: false,

      RMExchangePlatformmodal: false,
      RMExchangePlatformId: false,

      /**
         * 海康
         */
      HIKOffLinemodal: false,
      HIKOffLineId: false,

      HIK1DPositioningmodal: false,
      HIK1DPositioningId: false,

      HIKVideoLossmodal: false,
      HIKVideoLossId: false,

      HIKHardDiskNotDetectedmodal: false,
      HIKHardDiskNotDetectedId: false,

      HIKLossAttachmentmodal: false,
      HIKLossAttachmentId: false,

      HIKExchangePlatformmodal: false,
      HIKExchangePlatformId: false,

      /**
         * 中天
         */
      ZTOffLinemodal: false,
      ZTOffLineId: false,

      ZT1DPositioningmodal: false,
      ZT1DPositioningId: false,

      ZTVideoLossmodal: false,
      ZTVideoLossId: false,

      ZTHardDiskNotDetectedmodal: false,
      ZTHardDiskNotDetectedId: false,

      ZTLossAttachmentmodal: false,
      ZTLossAttachmentId: false,

      ZTExchangePlatformmodal: false,
      ZTExchangePlatformId: false,

      /**
         * 两客一危（省厅）
         */
      GDGOVParameterExceptionmodal: false,
      GDGOVParameterExceptionId: false,

      /**
         * 常见问题
         */
      WireCuttingAlarmmodal: false,
      WireCuttingAlarmId: false,

      /**
         * 超时驾驶
         */
      OvertimeDrivingAlarmmodal: false,
      OvertimeDrivingAlarmId: false,

      /**
         * 导出视频
         */
      ERPExportVideomodal: false,
      ERPExportVideoId: false,

      /**
         * 短信报警
         */
      ERPShortMessageWarningmodal: false,
      ERPShortMessageWarningId: false,

      /**
         * 对接平台
         */
      ERPExchangePlatformmodal: false,
      ERPExchangePlatformId: false,

      /**
         * 接入ERP/易流
         */
      ERPExchangeAccessmodal: false,
      ERPExchangeAccessId: false,

      Collapsevalue1: null,
      Collapsevalue: null
    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    openpdf (e) {
      this.Iframemodal = true
      this.IframeId = e
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
<style scoped>
</style>
